import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@coval/ui"

interface GenerateTestSetConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  selectedCount: number
  isLoading?: boolean
}

export function GenerateTestSetConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading = false,
}: GenerateTestSetConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Test Set Generation</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p>
            Are you sure you want to generate a new test set with{" "}
            {selectedCount} selected test{" "}
            {selectedCount === 1 ? "case" : "cases"}? This will create a new
            test set that you can use for future evaluations.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button variant="danger" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? "Generating…" : "Generate Test Set"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
